import { useEffect } from 'react'

export default function Analytics({
  path,
  apiEndpoint = '/api/analytics',
  enableLogging = false
}) {
  useEffect(() => {
    const trackPageView = async () => {
      try {
        const sessionId = localStorage.getItem('analytics_session') || 'new'
        const screenResolution = `${window.screen.width}x${window.screen.height}`

        if (enableLogging) {
          console.log('📊 Analytics: Tracking page view', {
            path: path || window.location.pathname,
            sessionId: sessionId === 'new' ? 'NEW SESSION' : 'EXISTING'
          })
        }

        const response = await fetch(apiEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            path: path || window.location.pathname,
            referrer: document.referrer,
            sessionId,
            screenResolution,
          }),
        })

        const data = await response.json()

        if (enableLogging) {
          console.log('📊 Analytics: Response', data)
        }

        if (data.success && data.sessionId) {
          localStorage.setItem('analytics_session', data.sessionId)
          if (enableLogging) {
            console.log('📊 Analytics: Session saved', data.sessionId)
          }
        }
      } catch (error) {
        if (enableLogging) {
          console.error('📊 Analytics tracking failed:', error)
        }
      }
    }

    trackPageView()
  }, [path, apiEndpoint, enableLogging])

  return null
}
